export const POI_CREATED_SOURCE = {
  TENANT_ADMIN: 'tenant_admin',
  CRAWL_DATA_SYSTEM: 'crawl_data_system',
} as const

export type PoiCreatedSource = (typeof POI_CREATED_SOURCE)[keyof typeof POI_CREATED_SOURCE]

/**
 * The backend stores/filters createdSource as these human-readable labels
 * ("Tenant Admin", "Crawl Data System"), not the snake_case enum values above.
 */
export const POI_CREATED_SOURCE_BACKEND_LABEL: Record<PoiCreatedSource, string> = {
  [POI_CREATED_SOURCE.TENANT_ADMIN]: 'Tenant Admin',
  [POI_CREATED_SOURCE.CRAWL_DATA_SYSTEM]: 'Crawl Data System',
}
